module.exports = __webpack_public_path__ + "img/visaindex.bdda010f.png";